import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import Div from "@jumbo/shared/Div";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@mui/material";
import { BASE_URL } from "app/services/auth-services";
import CustomTableHead from "app/shared/ReuseComponents/CustomTableHead";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";

const AttendanceDocumentApproval = ({
  openViewRequest,
  setOpenViewRequest,
  scrollHeight,
  requests,
  setRequests,
  setCloseRequest,
}) => {
  const headers = [
    { label: "Employee Name", boolean: true, sortKey: "Employee_Name" },
    { label: "Department", boolean: true, sortKey: "Department" },
    { label: "Days(M)", boolean: true, sortKey: "Days" },
    { label: "Days(P)", boolean: true, sortKey: "Nofodays_Present" },
    { label: "Days(A)", boolean: true, sortKey: "NoofDays_Leave" },
    // { label: "Days(H)", boolean: true, sortKey: "NoofDays_Holiday" },
    { label: "Leaves", boolean: true, sortKey: "Paid_Leave" },
  ];

  const getLeaveLabel = (name) => {
    if (!name) return "-";

    const lower = name.toLowerCase().trim();

    //  LOP exact
    if (lower === "lop") return "LOP";

    // any loss of pay
    if (lower.includes("loss")) return "LOP";

    //  sick leave
    if (lower.includes("sick")) return "S.L";

    //  casual leave
    if (lower.includes("casual")) return "C.L";

    // fallback (rare cases)
    return name;
  };

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const sortData = (key, direction) => {
    const sortedData = [...requests];

    sortedData.sort((a, b) => {
      const valueA = typeof a[key] === "string" ? a[key].toLowerCase() : a[key];
      const valueB = typeof b[key] === "string" ? b[key].toLowerCase() : b[key];
      if (valueA < valueB) {
        return direction === "ascending" ? -1 : 1;
      }
      if (valueA > valueB) {
        return direction === "ascending" ? 1 : -1;
      }
      return 0;
    });

    setRequests(sortedData);
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    sortData(key, direction);
  };

  useEffect(() => {
    const fetchAttendanceData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/Felix/AttendanceList/`, {
          params: {
            Partner_Id: requests?.Partner_Id,
            Year: requests?.Year,
            Month: requests?.Month,
          },
        });

        if (response?.data) {
          setRequests(response.data);
        }
      } catch (error) {
        console.error("Error fetching payslip data:", error);
      }
    };

    if (requests?.Partner_Id && requests?.Year && requests?.Month) {
      fetchAttendanceData();
    } else {
      console.warn("Missing required parameters for attendance fetch");
    }
  }, [requests?.Partner_Id, requests?.Year, requests?.Month]);

  return (
    <>
      <Dialog maxWidth="xl" fullWidth open={openViewRequest}>
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", mb: -2 }}
        >
          <Div sx={{ fontSize: "18px" }}>View Attendance</Div>
          <Div>
            <IconButton
              onClick={() => {
                setOpenViewRequest(false);
                setCloseRequest(true);
              }}
            >
              <MdClose />
            </IconButton>
          </Div>
        </DialogTitle>
        <DialogContent>
          <React.Fragment>
            <JumboScrollbar
              autoHeight={true}
              autoHideTimeout={4000}
              autoHeightMin={scrollHeight ? scrollHeight : 425}
              autoHide={true}
              hideTracksWhenNotNeeded
              id="no-more-tables"
            >
              <Table stickyHeader className="table">
                <CustomTableHead
                  headers={headers}
                  sortConfig={sortConfig}
                  handleSort={handleSort}
                  ActionMenus={{
                    cell: false,
                    actionIcon: false,
                  }}
                />

                <TableBody>
                  {requests?.length > 0 ? (
                    requests
                      ?.filter((opt) => opt?.Nofodays_Present > 0)
                      ?.map((data, index) => {
                        return (
                          <TableRow key={index} hover>
                            <TableCell
                              data-title="Employee Name"
                              sx={{
                                color: "#017890",
                                cursor: "pointer",
                              }}
                            >
                              <Typography
                                variant="h5"
                                sx={{
                                  color: "#017890",
                                  cursor: "pointer",
                                }}
                              >
                                {data?.EmployeeName} -{" "}
                                <span>{data?.Employee_Id} </span>
                              </Typography>
                              <Typography variant="h5">
                                {data?.Designation}
                              </Typography>
                            </TableCell>
                            <TableCell data-title="Department">
                              {data?.Department}
                            </TableCell>
                            <TableCell data-title="Days(M)">
                              {parseFloat(
                                data?.Attendance_Details?.length || 0,
                              )}
                            </TableCell>
                            <TableCell data-title="Days(P)">
                              {(() => {
                                const total =
                                  parseFloat(data?.Nofodays_Present || 0) +
                                  parseFloat(data?.NoofDays_Holiday || 0) +
                                  parseFloat(
                                    data?.Paid_Leave?.Total_Count || 0,
                                  );

                                return Number.isInteger(total)
                                  ? total
                                  : total.toFixed(1);
                              })()}
                            </TableCell>
                            <TableCell data-title="Days(A)">
                              {data?.UnPaid_Leave?.Total_Count || 0}
                              {Array.Object?.keys(data).map((key) => (
                                <div key={key}>
                                  <span>{key}: </span>
                                  <span>{data[key]}</span>
                                </div>
                              ))}
                            </TableCell>
                            {/* <TableCell data-title="Days(H)">
                                                        {data?.NoofDays_Holiday}
                                                    </TableCell> */}
                            <TableCell data-title="Leaves">
                              <Typography variant="h5">
                                {data?.Paid_Leave?.Leaves?.length > 0 ||
                                data?.UnPaid_Leave?.Leaves?.length > 0 ? (
                                  <>
                                    {data?.Paid_Leave?.Leaves?.map(
                                      (uniqueLeave) => {
                                        return (
                                          <Typography
                                            variant="h5"
                                            key={uniqueLeave}
                                          >
                                            {getLeaveLabel(
                                              uniqueLeave?.Leavename,
                                            )}{" "}
                                            : <span>{uniqueLeave?.Count}</span>
                                          </Typography>
                                        );
                                      },
                                    )}

                                    {data?.UnPaid_Leave?.Leaves?.map(
                                      (uniqueLeave) => {
                                        return (
                                          <Typography
                                            variant="h5"
                                            key={uniqueLeave}
                                          >
                                            {getLeaveLabel(
                                              uniqueLeave?.Leavename,
                                            )}{" "}
                                            :<span>{uniqueLeave?.Count}</span>
                                          </Typography>
                                        );
                                      },
                                    )}

                                    {/* {data?.Paid_Leave?.Leaves?.reduce((uniqueLeaves, opt) => {
                                                                        if (!uniqueLeaves.includes(opt?.Leavename)) {
                                                                            uniqueLeaves.push(opt?.Leavename);
                                                                        }
                                                                        return uniqueLeaves;
                                                                    }, []).map((uniqueLeave) => {
                                                                        const count = data?.Paid_Leave?.Leaves?.filter((opt) => opt?.Leavename === uniqueLeave).length;

                                                                        return (
                                                                            <Typography variant="h5" key={uniqueLeave}>
                                                                                {`${uniqueLeave?.slice(0, 1)}.L`} : <span>{count}</span>
                                                                            </Typography>
                                                                        );
                                                                    })} */}
                                  </>
                                ) : (
                                  <> - </>
                                )}
                              </Typography>
                            </TableCell>
                            {/* <TableCell data-title="Action">-</TableCell> */}
                          </TableRow>
                        );
                      })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No Records
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </JumboScrollbar>
          </React.Fragment>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AttendanceDocumentApproval;
